import {
  Button,
  Col,
  Input,
  Modal,
  Row,
  Upload,
  Typography,
  ConfigProvider,
} from "antd";
import { useEffect, useState } from "react";
import { MetadataTable } from "../../upload-page/sub-components/metadata-table";
import {
  ContainerData,
  MetadataCollection,
  MetadataItem,
  MetadataRowItem,
  MetadataTemplateItem,
} from "../../../api/data-types";
import { StorageAPIClient } from "../../../api/storage-api-client";

import { File } from "../../../api/data-types";

import "./metadata-preview.css";
import { RcFile } from "antd/es/upload";

interface MetadataEditModalProps {
  theme: string;
  isOpen: boolean;
  sendStateToParent: () => void;
  selectedContainer: ContainerData;
  selectedFile: File;
  metadata: MetadataCollection;
  closePreview: () => Promise<void>;
}

export const MetadataEditModal = ({
  theme,
  isOpen,
  sendStateToParent,
  selectedContainer,
  selectedFile,
  metadata,
  closePreview,
}: MetadataEditModalProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);

  const [metadataItems, setMetadataItems] = useState<MetadataRowItem[]>([]);

  const [countMetadata, setCountMetadata] = useState<number>(0);

  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const [metadataCheck, setMetadataCheck] = useState<boolean>(true);

  const handleAddMetadataItem = () => {
    setMetadataItems([
      ...metadataItems,
      new MetadataRowItem("", "", countMetadata),
    ]);
    setCountMetadata(countMetadata + 1);
  };

  const handleAddMetadataTemplate = (file: RcFile) => {
    let tmpMetadataTable: MetadataRowItem[] = [];
    let counter: number = 1;
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileAsString = e.target?.result as string;
      if (fileAsString !== null) {
        try {
          const JSONfile = JSON.parse(fileAsString);
          for (const [key, value] of Object.entries(JSONfile)) {
            if (typeof value === "string") {
              tmpMetadataTable = [
                ...tmpMetadataTable,
                new MetadataRowItem(key, value, countMetadata + counter),
              ];
              counter += 1;
            } else {
              tmpMetadataTable = [
                ...tmpMetadataTable,
                new MetadataRowItem(key, "", countMetadata + counter),
              ];
              counter += 1;
            }
          }
        } catch (error) {
          if (error instanceof Error) {
            setErrorMessage(error.message);
          } else {
            setErrorMessage("An unexpected error occurred.");
          }
        }
        for (let i = 0; i < selectedContainer.metadataTemplate.length; i++) {
          let index = tmpMetadataTable
            .map((item) => item.item.key)
            .indexOf(selectedContainer.metadataTemplate[i].key);
          if (index !== -1) {
            tmpMetadataTable[index].itemTemplate =
              selectedContainer.metadataTemplate[i];
            if (tmpMetadataTable[index].itemTemplate.readOnly) {
              tmpMetadataTable[index].item.value =
                tmpMetadataTable[index].itemTemplate.defaultValue;
            }
          } else {
            if (selectedContainer.metadataTemplate[i].required) {
              tmpMetadataTable = [
                ...tmpMetadataTable,
                new MetadataRowItem(
                  selectedContainer.metadataTemplate[i].key,
                  selectedContainer.metadataTemplate[i].defaultValue,
                  countMetadata + counter,
                  selectedContainer.metadataTemplate[i].required,
                  selectedContainer.metadataTemplate[i].readOnly,
                  selectedContainer.metadataTemplate[i].dataType,
                  true
                ),
              ];
              counter++;
            }
          }
        }
        setMetadataItems(tmpMetadataTable);
        setCountMetadata(countMetadata + counter);
      }
    };
    reader.readAsText(file);
    return false;
  };

  const handleRemoveMetadataItem = (key: number) => {
    const updatedData = metadataItems.filter(
      (item) => metadataItems.indexOf(item) !== key
    );
    setMetadataItems(updatedData);
  };

  const handleItemChange = (key: number, metadataItem: MetadataRowItem) => {
    let tmpMetadataItems: MetadataRowItem[] = Object.assign([], metadataItems);
    tmpMetadataItems[key] = metadataItem;
    setMetadataItems(tmpMetadataItems);
  };

  const resetMetadata = () => {
    let tmpMetadataItems: MetadataRowItem[] = [];
    let tmpCounter = countMetadata;
    Object.entries(metadata.metadataFromTemplate).map(([key, value]) => {
      let newMetadataItem = new MetadataRowItem(key, value, tmpCounter);
      tmpCounter++;
      tmpMetadataItems = [...tmpMetadataItems, newMetadataItem];
    });
    Object.entries(metadata.otherMetadata).map(([key, value]) => {
      let newMetadataItem = new MetadataRowItem(key, value, tmpCounter);
      tmpCounter++;
      tmpMetadataItems = [...tmpMetadataItems, newMetadataItem];
    });
    for (let i = 0; i < selectedContainer.metadataTemplate.length; i++) {
      let index = tmpMetadataItems
        .map((item) => item.item.key)
        .indexOf(selectedContainer.metadataTemplate[i].key);
      if (index !== -1) {
        tmpMetadataItems[index].itemTemplate =
          selectedContainer.metadataTemplate[i];
        if (tmpMetadataItems[index].itemTemplate.readOnly) {
          tmpMetadataItems[index].item.value =
            tmpMetadataItems[index].itemTemplate.defaultValue;
        }
      } else {
        if (selectedContainer.metadataTemplate[i].required) {
          tmpMetadataItems = [
            ...tmpMetadataItems,
            new MetadataRowItem(
              selectedContainer.metadataTemplate[i].key,
              selectedContainer.metadataTemplate[i].defaultValue,
              countMetadata + tmpCounter,
              selectedContainer.metadataTemplate[i].required,
              selectedContainer.metadataTemplate[i].readOnly,
              selectedContainer.metadataTemplate[i].dataType,
              true
            ),
          ];
          tmpCounter++;
        }
      }
    }
    setCountMetadata(tmpCounter);
    tmpMetadataItems = tmpMetadataItems.filter(
      (item) => item.item.key !== "FileGuid"
    );
    setMetadataItems(tmpMetadataItems);
  };

  const handleMetadatatemplateError = () => {
    setMetadataCheck(true);
    setErrorMessage(undefined);
    resetMetadata();
  };

  const handleMetadataCheckError = () => {
    setMetadataCheck(true);
    setErrorMessage(undefined);
  };

  async function onFinish() {
    let tmpMetadataItems: MetadataItem[] = [];
    let tmpMetadataCheck: boolean = true;
    setMetadataCheck(true);
    for (let i = 0; i < metadataItems.length; i++) {
      let item: MetadataItem = metadataItems[i].item;
      if (
        metadataItems[i].itemTemplate.fromConfiguration &&
        metadataItems[i].itemTemplate.readOnly
      ) {
        item.value = metadataItems[i].itemTemplate.defaultValue;
      }
      if (item.key === "" || item.key.trim() === "") {
        if (item.value !== "" && item.value.trim() !== "") {
          tmpMetadataCheck = false;
          break;
        }
      } else {
        if (item.value === "" || item.value.trim() === "") {
          if (metadataItems[i].itemTemplate.required) {
            if (metadataItems[i].itemTemplate.defaultValue !== "") {
              item.value = metadataItems[i].itemTemplate.defaultValue;
              tmpMetadataItems = [...tmpMetadataItems, item];
            } else {
              tmpMetadataCheck = false;
              break;
            }
          }
        } else {
          tmpMetadataItems = [...tmpMetadataItems, item];
        }
      }
    }
    if (!tmpMetadataCheck) {
      setMetadataCheck(false);
    } else {
      setLoading(true);
      StorageAPIClient.updateMetadata(
        selectedContainer.containerName,
        selectedFile,
        tmpMetadataItems
      )
        .then((response) => response.data)
        .then(async (json) => {
          if (json.status === "Success") {
            let newFile = selectedFile;
            tmpMetadataItems = [
              ...tmpMetadataItems,
              new MetadataItem("FileGuid", selectedFile.fileGuid),
            ];
            newFile.metaData = new MetadataCollection(
              selectedContainer.metadataTemplate,
              Object.assign(
                {},
                ...tmpMetadataItems.map((item) => ({ [item.key]: item.value }))
              )
            );
            await closePreview();
            setLoading(false);
          } else {
            setLoading(false);
            setErrorMessage(json.message);
          }
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    }
  }

  useEffect(() => {
    setIsVisible(isOpen);
    if (isOpen) {
      resetMetadata();
    }
  }, [isOpen]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <div>
      {!metadataCheck && (
        <Modal
          title="Error!"
          onOk={handleMetadataCheckError}
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          open={!metadataCheck}
        >
          <p style={{ color: textColor }} className="modalText">
            Please make sure that every required key has a value, there are no
            values without provided keys and that you have at least one
            key/value pair.
          </p>
        </Modal>
      )}
      {errorMessage !== undefined && (
        <Modal
          title="Error!"
          onOk={handleMetadatatemplateError}
          okButtonProps={{ style: { color: "black" } }}
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          open={errorMessage !== undefined}
        >
          <p style={{ color: textColor }}>`{errorMessage}`</p>
        </Modal>
      )}
      {metadataCheck && errorMessage === undefined && (
        <Modal
          className="modalEditMetadata"
          open={isVisible}
          closable={false}
          footer={[
            <Button
              type="default"
              key="cancel"
              onClick={() => {
                setIsVisible(false);
                sendStateToParent();
              }}
            >
              Cancel
            </Button>,
            <Button type="primary" key="ok" onClick={onFinish} loading={loading}>
              Save
            </Button>,
          ]}
        >
          <Col span={24}>
            <Row>
              <Col span={24} className="metadataTemplateModalButtonColumn">
                <Upload
                  accept=".json"
                  beforeUpload={handleAddMetadataTemplate}
                  showUploadList={false}
                >
                  <Button className="metadataTemplateModalButton">
                    Load metadata
                  </Button>
                </Upload>
              </Col>
            </Row>
            <Row>
              <Col
                span={24}
                className="metadataColumn"
                style={{ overflow: "auto" }}
              >
                <div>
                  <MetadataTable
                    isModal={true}
                    theme={theme}
                    metadataItems={metadataItems}
                    handleRemoveMetadataItem={handleRemoveMetadataItem}
                    handleItemChange={handleItemChange}
                    isMassUpdate={false}
                    selectedContainer={selectedContainer}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} className="addModalButtonColumn">
                <Button
                  className="addModalButton"
                  onClick={handleAddMetadataItem}
                >
                  Add
                </Button>
              </Col>
            </Row>
          </Col>
        </Modal>
      )}
    </div>
  );
};
